<template>
	<div class="login">
		<div class="login-box">
			<van-nav-bar @click-right="goHome">
				<template #left>
					<div class="left-text">
						<div class="logo"><img class="auto-img" src="../assets/images/coffee_icon.jpg" alt=""></div>
						<div class="logo-title">Luckin Coffee</div>
					</div>
				</template>
				<template #right>
					<div>先逛一逛</div>
				</template>
			</van-nav-bar>

			<div class="login-form">
				<div class="title">欢迎回来!</div>
				<div class="en-title">Please login to your <br />accounts</div>

				<div class="login-form-box">

					<van-form>
						<van-field placeholder="手机号" v-model="userLoginInfo.phone" />
						<van-field :type="isPassword ? 'password' : 'text'" placeholder="密码" v-model="userLoginInfo.password"
						 :right-icon="isPassword ? 'closed-eye' : 'eye-o'" @click-right-icon="viewPassword" />
						<div class="clearfix forgot">
							<span class="fr" @click="goForgot" >忘记密码?</span>
						</div>
						<div class="login-btn">
							<van-button round block type="info" native-type="submit" color="#212572" @click='login'>登&nbsp;&nbsp;录</van-button>
						</div>
						<div class="login-btn">
							<van-cell class="item-center" title="注册" @click="show = true" />
							<van-action-sheet v-model="show" title="注册" style="font-weight: bold;">
							  <div class="content">
								  <van-cell-group>
								    <van-field v-model="userRegister.phone" type="tel" placeholder="手机号 中国 (+86)" />
									<!-- <van-field v-model="userRegister.password" type="password" placeholder="密码首字母开头6到16位" /> -->
									<van-field :type="isPassword ? 'password' : 'text'" placeholder="密码首字母开头6到16位" v-model="userRegister.password"
									 :right-icon="isPassword ? 'closed-eye' : 'eye-o'" @click-right-icon="viewPassword" />
									<van-field v-model="userRegister.nickName" type="text" placeholder="昵称1到10位"  />
									<van-button block type="info" class="zhuce" native-type="submit" color="#212572" @click="register()">注&nbsp;&nbsp;册</van-button>
								  </van-cell-group>
							  </div>
							</van-action-sheet>
						</div>
					</van-form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import "../assets/less/login.less";

	import { validForm } from '../assets/js/ValidForm'
	
	import { utils } from '../assets/js/utils'
	
	export default {

		data() {
			return {
				show: false,
				value: '',
				userLoginInfo: {
					phone: '',
					password: ''
				},
				userRegister: {
					phone: '',
					password: '',
					nickName: ''
				},
				isPassword: true,
			};
		},
		
		
		methods: {
			goHome() {
				this.$router.push({name: "Home"});
			},
			showPopup() {
				this.show = true;
			},
			
			//忘记密码
			goForgot(){
				this.$router.push({name: 'Forgot'})
			},

			onSelect(item) {
				// 默认情况下点击选项时不会自动收起
				// 可以通过 close-on-click-action 属性开启自动收起
				this.show = false;
				Toast(item.name);
			},
			
			//查看密码
			viewPassword() {
				this.isPassword = !this.isPassword;
			},
			
			
			// 注册
			register() {
				let userInfo = this.userRegister;
				
					//验证注册表单
				let o = {
					phone: {
						value: userInfo.phone,
						reg: /^1[3-9]\d{9}$/,
						errorMsg: '手机号格式不正确'
					  },
					password:{
						value: userInfo.password,
						reg: /^[A-Za-z]\w{5,15}$/,
						errorMsg: '密码首字母开头6到16位'
					},
					nickName:{
						value: userInfo.nickName,
						reg: /^[\w\u4e00-\u9fa5]{1,10}$/,
						errorMsg: '昵称1到10位'
					}
				};
				
				if(!validForm.valid(o)){
					//验证不通过
					return;
				}
				
				
				//发起请求
				//开启加载提示
				this.$toast.loading({
					message: '加载中...',
					//防止穿透
					forbidClick: true,
					duration: 0,
					loadingType: 'spinner',
				})
				
				//序列化参数
				let info = Object.assign({}, userInfo);
				info.appkey = this.appkey;
				
				let data = utils.queryString(info);
				
				this.axios({
					method: 'POST',
					//请求参数
					url: '/register',
					data
				
				}).then(result =>{
					//关闭提示加载
					this.$toast.clear();
					this.$toast.success('成功注册');
					this.show = false;
							//如果注册成功
					if (result.data.code == 100){
						//清空注册表单的数据
						for(let key in userInfo){
							userInfo[key] = '';
						}
					}else{
						//如果注册失败，则提示
						this.$notify({
							type: 'warning', 
							message: result.data.msg
						})
					}
				}).catch(err =>{
					this.$toast.clear();
				})
			},	
				
				//登陆
				login(){
				let LoginInfo = this.userLoginInfo;
				let o = {
					 phone: {
						value: LoginInfo.phone,
						reg: /^1[3-9]\d{9}$/,
						errorMsg: '手机格式不正确'
					 },
					password:{
						value: LoginInfo.password,
						reg: /^[A-Za-z]\w{5,15}$/,
						errorMsg: '密码首字母开头6到16位'
					},
				};
				
				//验证表单
				if(!validForm.valid(o)){
					//验证不通过
					return;
				}
				
				
				//验证成功
				//开启加载提示
				this.$toast.loading({
					message: '加载中...',
					//防止穿透
					forbidClick: true,
					duration: 0,
					loadingType: 'spinner',
				})
				
				//复制userInfo
				let info = Object.assign({}, LoginInfo);
				info.appkey = this.appkey;
				
				
				//参数序列化
				let data = utils.queryString(info);
				
				this.axios({
					method: 'POST',
					url: '/login',
					data
				}).then(result =>{
					this.$toast.clear();
					if (result.data.code == 200) {
						localStorage.setItem('RETK', result.data.token);
						this.$router.push({name: 'Home'});
					}else{
						this.$notify({
							type: 'warning', 
							message: result.data.msg
						})
					}
				}).catch(err =>{
					this.$toast.clear();
				})
			}
		}			
	};
</script>
